module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/security/components/delete-role-confirmation-dialog.component.scss
// module id = ./src/app/security/components/delete-role-confirmation-dialog.component.scss
// module chunks = main